import React from "react";

const saee_chavan = () => {
  return (
    <div>
      <h1>Saee Chavan</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>CSI Internship Diaries 2025</strong>
      </p>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Initially there were 2 online tests 1 was a kind of a pro fit online
        test where in u had 8 /10 sections .This was a very long test which took
        me almost 2 and a half hours to attempt .It was based on personal
        opinions.After this if we passed the previous test ,we had to give a
        coding test .Time and accuracy was evaluated.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        My Technical Interview lasted for half an hour and the HR was for around
        15-20 minutes. It was on 26 th of
        August.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        There were 2 rounds as mentioned earlier .In the second round there were
        2 /3 questions one was very easy which was video based ,which means they
        had put up a video which consisted of a problem statement and then had
        to write the code accordingly.{" "}
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        Around 16 students were selected after the Aptitude Round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        We had received the shortlist 5 days prior to the{" "}
        interview. As it was HSBC’s first time
        for campus recruitments in our college ,I went through various websites
        and saw what did they expect in the interviews .So i prepared my
        projects thoroughly and also revised DSA (only till what i had done
        ,nothing new) .I also studied fundamental subjects like OOPS and
        DBMS(basics only).
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were 2 interview rounds ,1 technical and 1 HR .Technical round of
        almost everyone was for 30 minutes. The interviewer focused on DSA where
        i was asked to write pseudo code of 2 questions ,both were of easy
        level. One of the question was -There was a number made out of 6 and 9
        ‘s and i had only one swap to make the biggest possible number. Second
        one was based on frequency array and was related to strings . She also
        asked me various AI technologies present in the market right now and
        asked me if i was in favour of using AI or not. Based on projects , I
        wasnt asked anything technical but why you built this project and what
        was the accuracy and why is accuracy needed (for ML project).Then she
        also asked me what i knew about banking.
        <br />
        4 people were shortlisted for HR interviews (2 from each panel)
        <br />
        HR interview was quiet chill .The HR was just testing our confidence and
        the way we portray ourselves .He just asked me 2-3 common situation
        based questions for which i made answers on the spot. He also asked me
        what do you know about HSBC .<br />
        Finally all 4 of us got the offer.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        DSA and basic and common behavioral questions were focused .Other panel
        also asked DBMS and Backend based questions.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA by Love Babbar at start then slowly switching to Striver would
        really help for DSA .Striver Sheet can be followed ,For DBMS again Love
        Babbar and for OOPS what u learn in academics is more than enough .Try
        to include atleast 2 good projects in your resume .
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Just be consistent while preparing .I know there will be days when you
        will feel like just not doing anything but thats totally fine ! Take
        some rest and fuel up for the next day.Try to solve the questions by
        yourself first and then see the videos .Leetcode easy and medium
        questions are more than enough.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        In Tech Interview many questions on project were asked .HR asked me
        about the District Level Athlete Title mentioned in my resume. Honestly
        i dont think so clubs and all matter that much to them .But leadership
        does.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Yes ,Just be confident and portray yourself well.Even if u dont know the
        answer be calm and dont panic .Just say you will learn that in the
        break.
        <br />
        Ask some questions to the interviewers about the role offering and the
        company.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />I know this process is stressful but trust me once you get through
        it ,you will know all that u did was worth it !.Just dont loose hope
        ,Wishing youn all the best!
      </p>

      <p>
        <strong>Contact Info </strong>
      </p>

      <p>
        <strong>Email :</strong> <a href="mailto:saee20102005@gmail.com">saee20102005@gmail.com</a>
      </p>

      <hr />
    </div>
  );
};

export default saee_chavan;
